import { AxiosRequestConfig } from "axios";
import { defaultLogger } from "log/FieldProLogger";

import {
  DEFAULT_STACK_ERROR_TITLE,
  HTTP_REQUEST_STACK_KEY,
} from "./enhanceAxiosErrorStack";

interface IEnhancedAxiosConfig extends AxiosRequestConfig {
  topMostError?: Error;
}

export const logClientIdMissing = (config?: IEnhancedAxiosConfig): void => {
  if (!config || !config.url) return;

  const url = config.url as string;
  const error = config[HTTP_REQUEST_STACK_KEY] as Error | undefined;
  if (!error || !error.message) return;

  error.message = error.message.replace(
    DEFAULT_STACK_ERROR_TITLE,
    `[ClientIDNotSetError] - Client ID is not set for API request:${url}`,
  );

  defaultLogger?.logError(error);
};

export default logClientIdMissing;
